export * from './device-wipe.component';
